import { collection, getDocs, query, where } from 'firebase/firestore';
import { httpsCallable } from 'firebase/functions';
import { auth, cloudFunctions, db } from '../firebase';

export interface CustomDomain {
  domain: string;
  status: 'pending' | 'verified' | 'active';
  txtName?: string;
  txtValue?: string;
  dnsRecords?: Array<{ domainName: string; type: string; rdata: string; requiredAction: string }>;
  hostingError?: string;
}

export class DomainService {
  static async list(): Promise<CustomDomain[]> {
    const ownerId = auth.currentUser?.uid;
    if (!ownerId) throw new Error('Anmeldung erforderlich.');
    const snapshot = await getDocs(query(collection(db, 'custom-domains'), where('ownerId', '==', ownerId)));
    return snapshot.docs.map(item => ({ domain: item.data().domain || item.id, status: item.data().status || 'pending', txtName: `_redirectqr.${item.data().domain || item.id}`, txtValue: `redirectqr-verification=${ownerId}`, dnsRecords: item.data().hostingState?.dnsRecords || [], hostingError: item.data().hostingError || '' }));
  }

  static async verify(domain: string): Promise<CustomDomain> {
    const result = await httpsCallable<{ domain: string }, { domain: string; verified: boolean; active: boolean; txtName: string; txtValue: string; dnsRecords: CustomDomain['dnsRecords']; hostingError: string }>(cloudFunctions, 'verifyCustomDomain')({ domain });
    return { domain: result.data.domain, status: result.data.active ? 'active' : result.data.verified ? 'verified' : 'pending', txtName: result.data.txtName, txtValue: result.data.txtValue, dnsRecords: result.data.dnsRecords, hostingError: result.data.hostingError };
  }
}
